module.exports = __webpack_public_path__ + "img/download_button_ar.485ccc47.png";